const SCREENS = {
    MAIN: 0,
    ADD_PERSON: 1,
    ADD_GAME: 2,
};

export { SCREENS };
